var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "go-page-header-type2" }, [
        _c("div", { staticClass: "go-page-title" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("my-create.common.navbar.ask-goover")) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "go-section creates",
          staticStyle: { "margin-bottom": "20px" },
        },
        [
          _c("div", { staticClass: "go-section-body" }, [
            _c(
              "div",
              { staticClass: "go-card-main-grid my-creates" },
              _vm._l(_vm.widgetList, function (item, index) {
                return _c("chat-history-widget", {
                  key: index,
                  attrs: {
                    conversationId: item.conversationId,
                    title: item.title,
                    description: item.lastQuestion,
                    date: item.updatedDate,
                    "is-bookmark": item.isBookmark,
                    linkTitle: _vm.convertTitle(item),
                    "briefing-id": item.briefingId,
                    "chat-page": item.chatPage,
                    type: item.chatPage,
                    "report-id": item.reportId,
                  },
                  on: {
                    "view-history": function ($event) {
                      return _vm.viewHistoryConversation(item)
                    },
                    share: _vm.copyShareLink,
                    addBookmark: function ($event) {
                      return _vm.updateBookmark(item)
                    },
                    deleteConversation: _vm.deleteConversation,
                  },
                })
              }),
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.isNoData
        ? _c("NoDataComponent", {
            attrs: { title: _vm.MY_CREATE_TYPES.ASK_GOOVER },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loading ? _c("list-loading") : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "d-flex justify-content-center",
        staticStyle: { "margin-bottom": "50px" },
      }),
      _vm._v(" "),
      _c("chat-history-modal", {
        attrs: { open: _vm.historyOpenModal, item: _vm.currentConversation },
        on: {
          close: _vm.closeHistoryConversation,
          bookmark: _vm.updateBookmark,
          share: _vm.copyShareLink,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }